<template>
  <div class="relative inline-block text-left"
  @mouseenter="showPopover" @mouseleave="hidePopover">
  <slot name="element">
      <div class="inline-flex justify-center w-full rounded-md shadow-sm px-4 py-2">
          <i class="fas fa-info-circle"></i>
        </div>
    </slot>

    <transition
      enter-active-class="transition ease-out duration-100 transform"
      enter-from-class="opacity-0 scale-95"
      enter-to-class="opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75 transform"
      leave-from-class="opacity-100 scale-100"
      leave-to-class="opacity-0 scale-95"
    >
      <div
        v-if="isOpen"
        :class="'origin-top-right z-[100] absolute right-0 mt-2 w-fit rounded-md shadow-lg text-stone-900 dark:text-slate-100 bg-white dark:bg-slate-700 dark:border-slate-800 border ring-1 ring-black ring-opacity-5 focus:outline-none ' + styleOverwrite "
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="menu-button"
        tabindex="-1"
      >
        <div class="px-4 py-2" role="none">
           <div v-html="content"></div>
           <slot name="content">
           </slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
      content: String ,
      styleOverwrite: {
          type: String,
          default: ""
      }
  },
  data() {
    return {
      isOpen: false,
      debounce : null,
    };
  },
  methods: {
    showPopover() {
        clearTimeout(this.debounce);
      this.isOpen = true;
    },
    hidePopover() {
        if(this.debonce){
            clearTimeout(this.debounce);
        }
        this.debounce = setTimeout(() => {
            this.isOpen = false;
        }, 100);
    },
  },
};
</script>

<style scoped>
/* Optionally, you can add scoped styles here if needed */
</style>
